<template>
  <div class="wrapper">
    <base-bread-crumb :currBreadCrumb="currBreadCrumb"></base-bread-crumb>
    <div class="ccui-home-app-container-detail">
      <div class="ccui-app-container">
        <div class="notice-title">{{ pageData.title }}</div>
        <div class="color-1">
          <span class="pr20"
            >{{ $t("page.content.source") }}：{{ $t("page.content.add") }}</span
          >
          <span class="pr20"
            >{{ $t("page.content.author") }}：{{ pageData.author }}</span
          >
          <span
            >{{ $t("page.content.publishDate") }}：{{
              pageData.publishTime
            }}</span
          >
        </div>
        <el-divider></el-divider>
        <div v-html="pageData.textContent" style="line-break: anywhere;"></div>
        <!-- 附件信息 -->
        <attachmentUpload
          class="pt20"
          :type="2"
          :fileData="fileData"
          :isShowDesc="source === '1'"
          v-if="fileData.length > 0"
        ></attachmentUpload>
      </div>
    </div>
  </div>
</template>

<script>
import { queryNoticeById, getFaqProblemById } from "@/app/shop/api/shopping";
import baseBreadCrumb from "@/app/shop/components/baseBreadCrumb";
import attachmentUpload from "@/basa/components/common/attachmentUpload";
export default {
  name: "announcementDetail",
  components: {
    baseBreadCrumb,
    attachmentUpload
  },
  data() {
    return {
      pageData: {},
      currBreadCrumb: [],
      fileData: [],
      source: this.$route.query.source //1->供应商投标操作流程   else->公告详情
    };
  },
  activated() {
    if (this.source === "1") {
      this.currBreadCrumb.push({
        title: this.$t("page.content.supplierBiddingProcess")
      });
      this.initProcess();
    } else {
      this.currBreadCrumb.push({
        title: this.$t("page.content.Announcements"),
        path: "/announcementsList"
      });
      this.init();
    }
  },
  deactivated() {
    this.currBreadCrumb = [];
  },
  computed: {},
  methods: {
    init() {
      console.log(this.$route,'this.$route')
      queryNoticeById({
        noticeInfoId: this.$route_query.id,
        isShowPageLoading: true
      }).then(res => {
        if (res.data.code === "0") {
          this.pageData = res.data.data["noticeInfoBO"];
          this.fileData = res.data.data.basFileRelationBOs.map(item => {
            item.uploadId = item.fileInfoId;
            item.fileSize = Math.round(item.fileSize / 1024);
            return item;
          });
          this.currBreadCrumb.push({ title: this.pageData.title });
        }
      });
    },
    initProcess() {
      getFaqProblemById({
        faqId: this.$route_query.id
      }).then(res => {
        let item = res.data.data.faqProblemBO;
        this.pageData = {
          title: item.faqName,
          author: item.publishUser,
          publishTime: item.publishTime,
          textContent: item.textContent
        };
        this.fileData = res.data.data.fileList;
      });
    }
  }
};
</script>

<style scoped>
.ccui-home-app-container-detail {
  /*min-height: calc(100vh - 220px);*/
  margin: 0 auto 0 !important;
  padding: 0 0 0;
  min-width: 1180px;
}
</style>
